// Derive stats from the Athena-sourced invocations list.
// Used as a fallback when the realtime ring buffer is empty
// (e.g. after a component-server restart) but S3 archive still has records.
export function computeStatsFromInvocations(invocations) {
    if (!invocations || invocations.length === 0) return null;

    const total = invocations.length;
    let failures = 0;
    let coldStarts = 0;
    let throttles = 0;
    const durations = [];

    for (const inv of invocations) {
        const statusCode = parseInt(inv.status_code, 10);
        const isFailed = inv.status === "FAILURE" || statusCode >= 400;
        const isThrottled = inv.was_throttled === "true" || inv.status === "THROTTLED";
        if (isFailed) failures++;
        if (isThrottled) throttles++;
        if (inv.is_cold_start === "true") coldStarts++;
        const d = parseInt(inv.duration, 10);
        if (!Number.isNaN(d)) durations.push(d);
    }

    const errorRate = total > 0 ? Math.round((failures / total) * 10000) / 100 : 0;
    const sorted = durations.slice().sort((a, b) => a - b);
    const p95Index = Math.max(0, Math.ceil(sorted.length * 0.95) - 1);
    const p95Duration = sorted.length > 0 ? sorted[p95Index] : 0;
    const avgDuration =
        sorted.length > 0
            ? Math.round(sorted.reduce((a, b) => a + b, 0) / sorted.length)
            : 0;

    return {
        totalInvocations: total,
        failureCount: failures,
        throttleCount: throttles,
        coldStartCount: coldStarts,
        errorRate,
        p95Duration,
        avgDuration,
        maxDuration: sorted[sorted.length - 1] || 0,
        successCount: total - failures,
        coldStartRate: total > 0 ? Math.round((coldStarts / total) * 10000) / 100 : 0,
        avgMemoryUsed: null,
        invocationsPerMinute: 0,
        windowMinutes: 0,
        isFallback: true,
    };
}
